import { memo } from 'react';
import { EmployeeItem } from '../employee-item';
import { Employee } from '@features/add-participants-modal/model/useFetchEmployeesTree';

interface EmployeeListProps {
  employees: Employee[];
  isChecked: (id: number) => boolean;
  onToggle: (id: number) => void;
}
export const EmployeeList = memo(({ employees, isChecked, onToggle }: EmployeeListProps) => {
  return (
    <div>
      {employees.map((emp) => (
        <EmployeeItem
          key={emp.id}
          id={emp.id}
          firstName={emp.firstName}
          lastName={emp.lastName}
          position={emp.position ?? ''}
          checked={isChecked(emp.id)}
          onToggle={onToggle}
          isRemote={emp.isRemote}
        />
      ))}
    </div>
  );
});
